<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="12" class="mb-2">
        <label class="text-capitalize">{{ $tc("camera.title", 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="cameraFilter"
          :options="cameraOptions"
          class="w-100"
          multiple
          :reduce="val => val.value"
          @input="val => $emit('update:cameraFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="camera-filter"
        />
      </b-col>

      <b-col cols="12" md="6" class="mb-2">
        <base-date-time
          id="seproban_download_date_range_filter"
          :label="$t('seproban.download_date_range')"
          :value="downloadDateRange"
          mode="range"
          default-range-times
          date-format="Y-m-d H:i:S"
          :minute-increment="1"
          @input="value => $emit('update:downloadDateRange', value)"
        />
      </b-col>

      <b-col cols="12" md="6" class="mb-2">
        <base-date-time
          id="seproban_sent_date_range_filter"
          :label="$t('seproban.sent_date_range')"
          :value="sentDateRange"
          mode="range"
          default-range-times
          date-format="Y-m-d H:i:S"
          :minute-increment="1"
          @input="value => $emit('update:sentDateRange', value)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import { BaseDateTime } from "@/components/Form";
import popperHelper from "@/libs/popper-helper";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    BRow,
    BCol,
    vSelect,
    BaseDateTime,
  },
  props: {
    cameraOptions: {
      type: Array,
      default: () => [],
    },
    cameraFilter: {
      type: Array,
      default: () => [],
    },
    downloadDateRange: {
      type: String,
      default: "",
    },
    sentDateRange: {
      type: String,
      default: "",
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
